import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const BASE = `${API_URL}/v1/resource-manager/srv6-insight`;

function headers(token: string) {
    return { Authorization: `Bearer ${token}` };
}

export function getFilters(token: string) {
    return axios.get(`${BASE}/filters`, { headers: headers(token) });
}

export function getDistribution(
    token: string,
    source: string,
    timeRange = '1h'
) {
    return axios.get(`${BASE}/distribution`, {
        headers: headers(token),
        params: { source, timeRange },
    });
}

export function getTimeSeries(
    token: string,
    source: string,
    timeRange = '1h',
    interval = '1m'
) {
    return axios.get(`${BASE}/timeseries`, {
        headers: headers(token),
        params: { source, timeRange, interval },
    });
}

export function getLatency(
    token: string,
    source: string | null,
    timeRange = '1h',
    interval = '3m'
) {
    return axios.get(`${BASE}/latency`, {
        headers: headers(token),
        params: { source, timeRange, interval },
    });
}

export function getHeatmap(token: string, timeRange = '1h') {
    return axios.get(`${BASE}/heatmap`, {
        headers: headers(token),
        params: { timeRange },
    });
}

export function getAlerts(
    token: string,
    params: Record<string, string> = {}
) {
    return axios.get(`${BASE}/alerts`, {
        headers: headers(token),
        params,
    });
}

export function getDdm(
    token: string,
    params: Record<string, string> = {}
) {
    return axios.get(`${BASE}/ddm`, {
        headers: headers(token),
        params,
    });
}

export function getCoverage(token: string) {
    return axios.get(`${BASE}/coverage`, { headers: headers(token) });
}

export function getDdmByLink(
    token: string,
    params: Record<string, string> = {}
) {
    return axios.get(`${BASE}/ddm/by-link`, {
        headers: headers(token),
        params,
    });
}

export function getRecommendations(
    token: string,
    params: Record<string, string> = {}
) {
    return axios.get(`${BASE}/recommendations`, {
        headers: headers(token),
        params,
    });
}
